import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

import { UserPreference } from '@completion/enums';
import { getCurrentUserPreferences } from '@completion/selectors';
import { UserPreferenceService } from '@completion/services';

@Component({
  selector: 'app-user-preference-dialog',
  templateUrl: './user-preference-dialog.component.html',
  styleUrls: ['./user-preference-dialog.component.scss'],
  standalone: false,
})
export class UserPreferenceDialogComponent implements OnInit {
  readonly userPreference = UserPreference;
  useFlatTagTableView = false;

  constructor(
    private dialogRef: MatDialogRef<UserPreferenceDialogComponent>,
    private store: Store,
    private readonly userPreferenceService: UserPreferenceService,
  ) {}

  ngOnInit(): void {
    this.store
      .select(getCurrentUserPreferences)
      .pipe(take(1))
      .subscribe((preferences) => {
        this.userPreferenceService.initializeFromServer(preferences);
        this.useFlatTagTableView = this.userPreferenceService.isEnabled(UserPreference.USE_FLAT_TAG_TABLE_VIEW);
      });
  }

  onFlatTagTableToggle(enabled: boolean): void {
    this.useFlatTagTableView = enabled;
    this.userPreferenceService.setPreference(UserPreference.USE_FLAT_TAG_TABLE_VIEW, enabled);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
